/**
 * Week-start preference helpers.
 * Convention matches date-fns: 0 = Sunday, 1 = Monday, … 6 = Saturday.
 * Product v1 allows only Sunday (0) or Monday (1).
 */
/** Default when unset (product: Monday). */
export const DEFAULT_WEEK_STARTS_ON = 1;
export function resolveWeekStartsOn(weekStartsOn) {
    if (weekStartsOn === 0 ||
        weekStartsOn === 1 ||
        weekStartsOn === 2 ||
        weekStartsOn === 3 ||
        weekStartsOn === 4 ||
        weekStartsOn === 5 ||
        weekStartsOn === 6) {
        return weekStartsOn;
    }
    return DEFAULT_WEEK_STARTS_ON;
}
export function isAllowedWeekStartsOnV1(value) {
    return value === 0 || value === 1;
}
/**
 * Start of the week containing `date` (local midnight), for the given weekStartsOn.
 */
export function getWeekStart(date, weekStartsOn = DEFAULT_WEEK_STARTS_ON) {
    const currentDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    const dayOfWeek = currentDate.getDay();
    const daysBack = (dayOfWeek - weekStartsOn + 7) % 7;
    currentDate.setDate(currentDate.getDate() - daysBack);
    return currentDate;
}
/**
 * Day index within the user's week: 0 = first day of week (weekStartsOn).
 */
export function getDayIndexInWeek(date, weekStartsOn = DEFAULT_WEEK_STARTS_ON) {
    const localDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    return (localDate.getDay() - weekStartsOn + 7) % 7;
}
